<header class="dashletHead dashletHead__front" [class.dashletHead__front--disabled]="!ppCanEdit()">
  @if (ppDashlet().name !== EDashletType.COST_COMPARISON) {
    <div class="dashletHead__acc-site">
      <p class="dashletHead__account" ppTooltip [ppTitle]="accountTooltip" [ppSanitize]="false">
        {{ accountName }}
      </p>
      <p
        class="dashletHead__site"
        [class.dashletHead__site--renamable]="renameDashletsEnabled"
        ppTooltip
        [ppTitle]="siteTooltip"
        [ppSanitize]="false"
      >
        {{ siteName }}
      </p>
    </div>
  }

  <div class="dashletHead__title-front">
    <span class="dashletHead__title-front__title">
      {{ title }}
      @if (tooltipText) {
        <pp-icon
          [ppSrc]="EIconPath.ICON_BANNER_INFO_24"
          ppTooltip
          [ppTitle]="tooltipText"
          ppClass="setSize24"
          ppColor="inherit"
        ></pp-icon>
      }
    </span>
    @if (ppDashlet().customName && renameDashletsEnabled) {
      <span
        class="dashletHead__title__custom"
        [class.dashletHead__title__custom--renamable]="renameDashletsEnabled"
        ppTooltip
        [ppTitle]="ppDashlet().customName"
        >{{ ppDashlet().customName }}</span
      >
    }
  </div>

  @if (ppCanEdit()) {
    <button
      data-m-target="Dashlet settings button"
      class="dashletHead__button"
      (click)="flipDashlet()"
    >
      <pp-icon [ppSrc]="EIconPath.ICON_NAV_COG_24" ppClass="setSize24" ppColor="inherit" />
    </button>
  }
</header>

<header class="dashletHead dashletHead__back" data-m-target="Dashlet settings back button">
  <button class="dashletHead__backButton" (click)="ppToggleFlip.emit()">
    <pp-icon
      [ppSrc]="EIconPath.ICON_LEFT_MENU_ARROW_BACK_14"
      ppColor="inherit"
      ppClass="setSize14"
    ></pp-icon>
    <p class="dashletHead__backButton--text">
      {{ 'back' | ppTranslate }}
    </p>
  </button>

  @if (renameDashletsEnabled) {
    <pp-rename-dashlet
      [ppDashlet]="ppDashlet()"
      (ppDashletChange)="onDashletChange($event)"
      (ppSave)="onDashletSave()"
    ></pp-rename-dashlet>
  }

  <h5 class="dashletHead__title">{{ 'dashlet_settings' | ppTranslate }}</h5>
</header>
